import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import UserIcon from "../../components/common/UserIcon";
import NotificationCenter from "../../components/common/NotificationCenter";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { usePrivacy } from "../../contexts/PrivacyContext";

export const HomeHeader = ({ text, link, showPrivacyButton = false }) => {
    const { isPrivacyMode, togglePrivacyMode } = usePrivacy();

    return(
        <Wrapper>
            <Title>
                <Font1>
                    <StyledLink to ={link}>TeamCAST</StyledLink>
                </Font1>
                <Font2>{text}</Font2>
            </Title>
            <Actions>
                {showPrivacyButton && (
                    <MuteButton
                        onClick={togglePrivacyMode}
                        $active={isPrivacyMode}
                        title={isPrivacyMode ? "Privacy mode on — click to show real names" : "Click to hide student info"}
                    >
                        {isPrivacyMode ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                        {isPrivacyMode ? "Privacy On" : "Privacy Off"}
                    </MuteButton>
                )}
                <NotificationCenter/>
                <UserIcon/>
            </Actions>
        </Wrapper>
    );
};

const Actions = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;

    @media (max-width: 600px) {
      gap: 6px;
    }
`;

const MuteButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    border-radius: 8px;
    border: 1.5px solid ${props => props.$active ? '#9333ea' : '#d1d5db'};
    background: ${props => props.$active ? '#f3e8ff' : '#fff'};
    color: ${props => props.$active ? '#7e22ce' : '#6b7280'};
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.15s ease;

    &:hover {
        border-color: #9333ea;
        color: #7e22ce;
        background: #f3e8ff;
    }

    @media (max-width: 600px) {
        padding: 6px 8px;
        font-size: 0;
        gap: 0;
    }
`;

const Wrapper = styled.div`
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
    z-index: 100; /* Ensure it's above other elements */
    position: sticky;
    top: 0;
    padding: 20px 28px;
`;

const Title = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const Font1 = styled.h1`
    font: 600 30px Infer, sans-serif;
    color: #111827;
`;

const Font2 = styled.h2`
    font-family: 'Inter', sans-serif;
    font-size: 1.125rem;    /* text-lg */
    line-height: 1.75rem;
    color: #6b7280;         /* text-gray-500 */
    margin-left: 20px;
    font-weight: 500;
`;

const StyledLink = styled(Link)`
    all: unset;
    cursor: pointer;
`;
